import { EcareState } from "./types";

const state: EcareState = {
  dashboards: [],
  selectedTab: "dashboard",
  editorVisible: false,
};

export default state;
